import { mergeWithComponentCustomizedStyles } from 'conversional-theme';
import { generateClasses } from "../../utilities/components/styles";
var Styles = function (theme) {
    var staticStyles = ({
        tooltipContainer: {
            position: "absolute",
            top: "50%",
            transform: "translateY(-50%)",
            right: 10
        },
        popover: {
            pointerEvents: 'none'
        },
        popoverContent: {
            pointerEvents: 'auto',
            maxWidth: "300px !important",
            wordWrap: "word-break",
            padding: 15,
            background: "".concat(theme.colors.surface_light, " !important"),
            color: "".concat(theme.colors.carbon, " !important")
        }
    });
    return mergeWithComponentCustomizedStyles(theme, "formFieldTooltip", staticStyles);
};
export var getStyles = generateClasses(Styles);
